<div class="mce-color-btn-wrapper">

  <!-- Trigger button -->
  <button type="button" class="mce-color-trigger" (click)="toggle()" [title]="label()">
    <ng-content />
    <mat-icon class="mce-color-chevron">keyboard_arrow_down</mat-icon>
  </button>

  <!-- Dropdown palette -->
  @if (open) {
    <div class="mce-color-palette">

      <!-- Remove colour -->
      <button type="button" class="mce-color-remove" (click)="select(null)">
        <mat-icon>format_color_reset</mat-icon>
        {{ removeLabel() }}
      </button>

      <!-- Colour swatches -->
      <div class="mce-color-grid">
        @for (color of colors; track color) {
          <button type="button" class="mce-color-swatch-btn"
                  [style.background]="color"
                  [class.mce-color-swatch-btn--active]="currentColor() === color"
                  [title]="color"
                  (click)="select(color)">
          </button>
        }
      </div>

      <div class="mce-color-divider"></div>

      <!-- Native color picker -->
      <button type="button" class="mce-color-remove" (click)="openPicker(colorInput)">
        <mat-icon>colorize</mat-icon>
        Color picker
      </button>
      <input #colorInput type="color" class="mce-color-input" [value]="currentColor() ?? '#000000'"
             (change)="pickerChanged(colorInput)" />

    </div>
  }

</div>
